import { Component } from '@angular/core';

@Component({
  selector: 'app-organization-configuration',
  templateUrl: './organization-configuration.component.html',
  styleUrl: './organization-configuration.component.scss',
  standalone: false,
})
export class OrganizationConfigurationComponent { }
